<script lang="ts" setup>
const { gtm } = useRuntimeConfig().public
usePageHead()
const code = useRouteParams<string | null>('code', null)
</script>

<template>
  <ContentHeaderMeta :product-code="code" />
  <div class="min-h-screen flex flex-col">
    <div
      class="absolute z-[-10] h-[500px] w-full bg-gradient-to-t from-primary-950 to-primary-700"
    />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <PvToast />
    <PvConfirmDialog>
      <template #container="slotProps">
        <div class="flex flex-col gap-4 p-6">
          <p>{{ slotProps.message.message }}</p>

          <div class="flex justify-center gap-2">
            <PvButton
              :label="slotProps?.message?.rejectProps?.label ?? 'Cancelar'"
              severity="contrast"
              outlined
              @click="slotProps?.rejectCallback()"
            />
            <PvButton
              :label="slotProps?.message?.acceptProps?.label ?? 'Continuar'"
              @click="slotProps?.acceptCallback()"
            />
          </div>
        </div>
      </template>
    </PvConfirmDialog>
    <!-- Google Tag Manager (noscript) -->
    <ClientOnly>
      <noscript v-if="gtm?.enable">
        <iframe
          :src="`https://www.googletagmanager.com/ns.html?id=${gtm?.id}`"
          height="0"
          width="0"
          style="display: none; visibility: hidden"
        >
        </iframe>
      </noscript>
    </ClientOnly>
    <!-- End Google Tag Manager (noscript) -->
  </div>
</template>
